<!-- start app-close -->
<div class="close d-inline-block">
    <app-plus-icon [circle]="true" />
</div>
<!-- end app-close -->